<template>
<div class="col-sm-8 col-sm-offset-2">
  <div class="card float-e-margins">
    <div class="card-content">
    <div class="row" v-if="!loaded">
      <div class="col-xs-2 col-xs-offset-5">
        <img class="img" src="../../assets/img/ajax_loader.gif" style="height:50px;width:50px">
      </div>
      <div class="col-xs-12 text-center">
          <p>U wordt doorverwezen, een ogenblik geduld aub..</p>
      </div>
    </div>
    <div class="row" v-if="loaded">
      <h1 class="text-center">Betaling ontvangen!</h1>
      <h2 class="text-center text-success"><i class="fa fa-check-circle-o fa-5x" aria-hidden="true"></i></h2>
      <h4>
      Hartelijk dank voor je bestelling. We hebben je betaling in goede orde ontvangen en zullen je bestelling zo snel mogelijk aan de vervoerder afleveren. 
      </h4>
      <h4>
      Je ontvangt per e-mail een bevestiging van je bestelling. In deze e-mail vindt je ook de factuur.
      </h4>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import store from '../../store'
export default {
  created () {
    var self = this
    var burl = self.$route.params.burl
    var date = self.$route.params.date
    $.ajax({
      type: 'POST',
      url: store.root + 'api/checkout/postback?burl=' + burl + '&date=' + date,
      xhrFields: {
        withCredentials: true
      }
    }).done(function () {
      self.success = true
      self.error = false
      self.loaded = true
    }).fail(function (response) {
      // console.log(response)
      self.success = false
      self.error = true
      self.loaded = false
    })
  },
  components: {
    store: store
  },
  data () {
    return {
      loaded: false
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// betaling-succesvol.vue?ca5e44b6